import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes";
import "./assets/css/bootstrap.css";
import "./assets/css/style.css";
import "./components/global.js";
import skeleton from "./components/skeleton.js";

if (localStorage.getItem("mode") === "dark") document.body.classList.add("dark");

// เริ่มแอปในสถานะกำลังโหลด (เดิมวงหมุนแสดงตั้งแต่แรก) หน้าเรียก loading(false) เมื่อโหลดเสร็จ
skeleton(true, true);

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <Routes />
  </BrowserRouter>
);
